import { connected, disconnected, messageReceived, errorOccurred } from '../slices/socketSlice';

let activeSocket = null;

export const websocketMiddleware = (store) => (next) => (action) => {
	if (action.type === 'socket/connect') {
		try {
			if (activeSocket) {
				activeSocket.close();   
			}
			const endpoint = action.payload;
			activeSocket = new WebSocket(endpoint);

			activeSocket.onopen = () => {
				store.dispatch(connected());
			};

			activeSocket.onmessage = (event) => {
				try {
					const data = JSON.parse(event.data);
					store.dispatch(messageReceived(data));
				} catch (err) {
					store.dispatch(errorOccurred('Invalid JSON in socket message'));
				}
			};

			activeSocket.onerror = (err) => {
				store.dispatch(errorOccurred('WebSocket error'));
			};

			activeSocket.onclose = () => {
				store.dispatch(disconnected());
			};
		} catch (err) {
			store.dispatch(errorOccurred('WebSocket init failed'));
		}
	}

	if (action.type === 'socket/disconnect') {
		if (activeSocket) {
			activeSocket.close();
			activeSocket = null;
		}
	}

	if (action.type === 'socket/send' && activeSocket && activeSocket.readyState === WebSocket.OPEN) {
		const message = typeof action.payload === 'string' ? action.payload : JSON.stringify(action.payload);
		activeSocket.send(message);
	}

	return next(action);
};


